import React from 'react'

export default function NoPage() {
  return (
    <div>You have a reached a page that doesn't exist!</div>
  )
}
